<template>

  <div id="app">
    <v-app id="inspire">
      <v-layout align-center justify-center>

        <v-snackbar
          :value="$store.getters.error"
          color="error"
          :top="true"
          :multi-line="true"
          :auto-height="true"
          :timeout="6000"
          :vertical="false"
        >
          <m-pay-error-message :error="$store.getters.error" :login="true"/>
          <v-btn dark flat @click="clearMessages">
            Close
          </v-btn>
        </v-snackbar>

        <v-flex xs12 sm8 md4>
          <v-card class="elevation-3 pb-3">

            <div v-if="passwordResetMode">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Reset password</v-toolbar-title>
              </v-toolbar>

              <div v-if="showResetForm">
                <m-pay-password-form
                  :loading="loading"
                  :submit-callback="resetPassword"
                  button-label="Reset Password"
                ></m-pay-password-form>
              </div>

              <div v-else>
                <v-card-text v-if="showTokenInvalid" class="py-5">
                  Password reset URL has expired. Please request a new one.
                </v-card-text>
                <v-card-text v-else class="py-5">
                  Password was reset successfully
                </v-card-text>

                <v-card-actions class="mr-2">
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" @click="returnToLoginPage">
                    Return to login page</v-btn>
                </v-card-actions>
              </div>

            </div>

            <div v-else>
              <v-toolbar dark color="primary">
                <v-toolbar-title>Password recovery</v-toolbar-title>
              </v-toolbar>

              <div v-if="instructionsSent">
                <v-card-text v-if="instructionsSent" class="py-5">
                  Check your email for a link to reset your password.
                  If it doesn't appear within a few minutes, check your spam folder.
                </v-card-text>

                <v-card-actions class="mr-2">
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" @click="returnToLoginPage">
                    Return to login page</v-btn>
                </v-card-actions>
              </div>

              <div v-else>
                <v-card-text>
                  <v-form>
                    <v-text-field v-model="email" label="Your email address"
                                  name="email" type="email" autofocus prepend-icon="email"
                                  v-validate="'required|email'" data-vv-delay="500"
                                  :error-messages="errors.collect('email')"
                                  @keydown.enter.prevent="recoverPassword">
                    </v-text-field>
                  </v-form>
                </v-card-text>

                <v-card-actions class="mr-2">
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" @click="recoverPassword" :disabled="loading">
                    Send password recovery instructions</v-btn>
                </v-card-actions>
              </div>

            </div>
          </v-card>
        </v-flex>

      </v-layout>
    </v-app>
  </div>

</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayErrorMessage from '../MPayErrorMessage';
import MPayPasswordForm from '../MPayPasswordForm';

export default {
  components: { MPayPasswordForm, MPayErrorMessage },
  data: () => ({
    loading: false,
    passwordResetMode: false,
    showResetForm: true,
    instructionsSent: false,
    email: '',
  }),
  methods: {
    recoverPassword() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            this.loading = true;
            axios.post(queries.recoverPassword(), { email: this.email })
              .then(() => {
                this.loading = false;
                this.instructionsSent = true;
              })
              .catch((e) => {
                this.showError(e);
                this.loading = false;
              });
          }
        });
    },
    resetPassword(password) {
      this.loading = true;
      axios.post(queries.resetPassword(), {
        token: this.$route.query.reset,
        newPassword: password,
      }).then((success) => {
        this.loading = false;
        this.showResetForm = false;
        if (success.data === false) {
          this.showTokenInvalid = true;
        }
      }).catch((e) => {
        this.showError(e);
        this.loading = false;
      });
    },
    returnToLoginPage() {
      this.$router.push('login');
    },
  },
  created() {
    if (this.$route.query.reset) {
      this.passwordResetMode = true;
    }
    this.$validator.localize('en', {
      custom: {
        email: {
          required: 'Please enter your email address',
          email: 'Email address is invalid',
        },
      },
    });
  },
};

</script>



// WEBPACK FOOTER //
// src/components/login/MPayPasswordRecovery.vue